/* eslint-disable react/no-unescaped-entities */
// app/page.tsx
'use client';

import { useState } from 'react';
import Link from 'next/link';

export default function Home() {
  const [cartCount, setCartCount] = useState(0);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const products = [
    {
      id: 1,
      name: "Professional DSLR Camera",
      price: 1299.99,
      image: "https://images.unsplash.com/photo-1516035069371-29a1b244cc32?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=800&q=80",
      category: "Cameras"
    },
    {
      id: 2,
      name: "Studio Lighting Kit",
      price: 459.99,
      image: "https://images.unsplash.com/photo-1581591524425-c7e0978865fc?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=800&q=80",
      category: "Lighting"
    },
    {
      id: 3,
      name: "Portrait Lens 85mm f/1.4",
      price: 899.99,
      image: "https://images.unsplash.com/photo-1606983340126-99ab4feaa64a?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=800&q=80",
      category: "Lenses"
    },
    {
      id: 4,
      name: "Carbon Fiber Tripod",
      price: 289.99,
      image: "https://images.unsplash.com/photo-1554048612-b6a482bc67e5?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=800&q=80",
      category: "Support"
    },
    {
      id: 5,
      name: "Camera Drone Pro",
      price: 1499.99,
      image: "https://images.unsplash.com/photo-1507582020474-9a35b7d455d9?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=800&q=80",
      category: "Drones"
    },
    {
      id: 6,
      name: "Professional Editing Software",
      price: 299.99,
      image: "https://images.unsplash.com/photo-1611224923853-80b023f02d71?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=800&q=80",
      category: "Software"
    },
  ];

  const categories = [
    { name: "Cameras", count: 8, icon: "📷" },
    { name: "Lenses", count: 12, icon: "🔍" },
    { name: "Lighting", count: 6, icon: "💡" },
    { name: "Drones", count: 4, icon: "🚁" },
  ];

  const services = [
    {
      title: "Studio Rental",
      description: "Professional photography studio with various backdrops and equipment",
      icon: "🎬"
    },
    {
      title: "Photo Editing",
      description: "Expert photo retouching and editing services",
      icon: "✨"
    },
    {
      title: "Photography Workshops",
      description: "Learn from professional photographers",
      icon: "🎓"
    },
    {
      title: "Equipment Repair",
      description: "Fast and reliable camera repair services",
      icon: "🔧"
    },
  ];

  const addToCart = () => {
    setCartCount(cartCount + 1);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header/Navigation */}
      <header className="sticky top-0 z-50 bg-white shadow-md">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            {/* Logo */}
            <Link href="/" className="text-2xl font-bold text-teal-600 flex items-center">
              <span className="mr-2">📸</span> PhotoStudio
            </Link>

            {/* Desktop Navigation */}
            <nav className="hidden md:flex space-x-8">
              <Link href="/" className="text-gray-700 hover:text-teal-600 transition font-medium">Home</Link>
              <Link href="/shop" className="text-gray-700 hover:text-teal-600 transition font-medium">Shop</Link>
              <Link href="/services" className="text-gray-700 hover:text-teal-600 transition font-medium">Services</Link>
              <Link href="/gallery" className="text-gray-700 hover:text-teal-600 transition font-medium">Gallery</Link>
              <Link href="/contact" className="text-gray-700 hover:text-teal-600 transition font-medium">Contact</Link>
            </nav>

            {/* Search, Cart, and Auth */}
            <div className="flex items-center space-x-4">
              <div className="hidden md:block relative">
                <input
                  type="text"
                  placeholder="Search products..."
                  className="pl-10 pr-4 py-2 border border-gray-300 rounded-full focus:ring-2 focus:ring-teal-500 focus:border-teal-500 text-sm"
                />
                <svg className="w-5 h-5 text-gray-400 absolute left-3 top-2.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
                </svg>
              </div>

              <div className="relative">
                <button className="text-gray-700 hover:text-teal-600 transition p-2 bg-gray-100 rounded-full">
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"></path>
                  </svg>
                  {cartCount > 0 && (
                    <span className="absolute -top-1 -right-1 bg-teal-600 text-white text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center">
                      {cartCount}
                    </span>
                  )}
                </button>
              </div>

              <button className="hidden md:block bg-teal-600 text-white px-4 py-2 rounded-full hover:bg-teal-700 transition font-medium text-sm">
                Sign In
              </button>

              {/* Mobile menu button */}
              <button className="md:hidden p-2 rounded-md text-gray-700" onClick={() => setIsMenuOpen(!isMenuOpen)}>
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16"></path>
                </svg>
              </button>
            </div>
          </div>

          {/* Mobile Navigation */}
          {isMenuOpen && (
            <div className="md:hidden mt-4 pb-4 border-t border-gray-200 pt-4">
              <div className="relative mb-4">
                <input
                  type="text"
                  placeholder="Search products..."
                  className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-full focus:ring-2 focus:ring-teal-500 focus:border-teal-500 text-sm"
                />
                <svg className="w-5 h-5 text-gray-400 absolute left-3 top-2.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
                </svg>
              </div>
              <nav className="flex flex-col space-y-3">
                <Link href="/" className="text-gray-700 hover:text-teal-600 transition font-medium">Home</Link>
                <Link href="/shop" className="text-gray-700 hover:text-teal-600 transition font-medium">Shop</Link>
                <Link href="/services" className="text-gray-700 hover:text-teal-600 transition font-medium">Services</Link>
                <Link href="/gallery" className="text-gray-700 hover:text-teal-600 transition font-medium">Gallery</Link>
                <Link href="/contact" className="text-gray-700 hover:text-teal-600 transition font-medium">Contact</Link>
                <button className="bg-teal-600 text-white px-4 py-2 rounded-full hover:bg-teal-700 transition font-medium w-full mt-2">
                  Sign In
                </button>
              </nav>
            </div>
          )}
        </div>
      </header>

      <main>
        {/* Hero Section */}
        <section className="relative bg-gradient-to-r from-gray-900 to-gray-800 text-white py-20 overflow-hidden">
          <div className="absolute inset-0 bg-black opacity-50"></div>
          <div className="container mx-auto px-4 relative z-10 flex flex-col md:flex-row items-center">
            <div className="md:w-1/2 mb-10 md:mb-0">
              <h1 className="text-4xl md:text-5xl font-bold mb-6">Capture Perfect Moments</h1>
              <p className="text-xl mb-8 text-gray-300">Professional photography equipment and studio services for creatives.</p>
              <div className="flex flex-col sm:flex-row gap-4">
                <button className="bg-teal-600 text-white px-8 py-4 rounded-lg hover:bg-teal-700 transition font-medium shadow-lg">
                  Shop Equipment
                </button>
                <button className="border border-white text-white px-8 py-4 rounded-lg hover:bg-white/10 transition font-medium">
                  Book Studio
                </button>
              </div>
            </div>
            <div className="md:w-1/2 flex justify-center">
              <div className="relative w-80 h-80 rounded-full overflow-hidden border-4 border-white/20 shadow-2xl">
                <div className="absolute inset-0 bg-gradient-to-br from-teal-500 to-purple-600 opacity-70"></div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="text-center p-8">
                    <span className="text-6xl mb-4 block">📷</span>
                    <h3 className="text-2xl font-bold">Professional Grade</h3>
                    <p className="mt-2">Equipment & Services</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Services Section */}
        <section className="py-16 bg-white">
          <div className="container mx-auto px-4">
            <h2 className="text-3xl font-bold text-center mb-4">Our Services</h2>
            <p className="text-gray-600 text-center max-w-2xl mx-auto mb-12">We offer a complete range of photography services and equipment rentals.</p>
            
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              {services.map((service, index) => (
                <div key={index} className="bg-gray-50 p-6 rounded-xl hover:shadow-md transition text-center">
                  <div className="text-4xl mb-4">{service.icon}</div>
                  <h3 className="text-xl font-bold mb-2">{service.title}</h3>
                  <p className="text-gray-600">{service.description}</p>
                  <button className="mt-4 text-teal-600 hover:text-teal-800 font-medium text-sm">
                    Learn more →
                  </button>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Categories Section */}
        <section className="py-16 bg-gray-100">
          <div className="container mx-auto px-4">
            <h2 className="text-3xl font-bold text-center mb-4">Shop By Category</h2>
            <p className="text-gray-600 text-center max-w-2xl mx-auto mb-12">Find the perfect equipment for your photography needs.</p>
            
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              {categories.map((category, index) => (
                <div key={index} className="bg-white rounded-xl overflow-hidden shadow-md hover:shadow-lg transition">
                  <div className="h-48 bg-gradient-to-br from-teal-500 to-purple-600 flex items-center justify-center">
                    <span className="text-6xl text-white">{category.icon}</span>
                  </div>
                  <div className="p-6">
                    <h3 className="text-xl font-bold mb-2">{category.name}</h3>
                    <p className="text-gray-600">{category.count} products</p>
                    <button className="mt-4 w-full bg-teal-600 text-white py-2 rounded-lg hover:bg-teal-700 transition font-medium">
                      Browse
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Featured Products */}
        <section className="py-16 bg-white">
          <div className="container mx-auto px-4">
            <div className="flex justify-between items-center mb-12">
              <h2 className="text-3xl font-bold">Featured Products</h2>
              <Link href="/shop" className="text-teal-600 hover:text-teal-800 font-medium">
                View All Products →
              </Link>
            </div>
            
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
              {products.map((product) => (
                <div key={product.id} className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-xl transition">
                  <div className="h-64 bg-gradient-to-br from-gray-200 to-gray-300 flex items-center justify-center">
                    <div className="text-center">
                      <div className="w-40 h-40 mx-auto bg-gray-400 rounded-lg mb-4"></div>
                      <h3 className="font-bold text-lg">{product.name}</h3>
                    </div>
                  </div>
                  <div className="p-6">
                    <div className="flex justify-between items-center mb-4">
                      <span className="text-2xl font-bold text-gray-800">${product.price.toFixed(2)}</span>
                      <span className="text-sm text-gray-600 bg-gray-100 px-3 py-1 rounded-full">{product.category}</span>
                    </div>
                    <button 
                      onClick={addToCart}
                      className="w-full bg-teal-600 text-white py-3 rounded-lg hover:bg-teal-700 transition font-medium flex items-center justify-center"
                    >
                      <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path>
                      </svg>
                      Add to Cart
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Promo Section */}
        <section className="py-16 bg-gradient-to-r from-teal-600 to-purple-600 text-white">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto text-center">
              <h2 className="text-3xl font-bold mb-6">Join Our Photography Community</h2>
              <p className="text-xl mb-8">Get exclusive discounts, photography tips, and early access to new products.</p>
              
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <input 
                  type="email" 
                  placeholder="Enter your email" 
                  className="px-6 py-4 rounded-lg text-gray-800 focus:ring-2 focus:ring-teal-300 focus:outline-none flex-grow max-w-md"
                />
                <button className="bg-white text-teal-600 px-8 py-4 rounded-lg hover:bg-gray-100 transition font-medium whitespace-nowrap">
                  Subscribe
                </button>
              </div>
              
              <p className="text-sm mt-4 text-teal-100">By subscribing, you agree to our Terms and Privacy Policy.</p>
            </div>
          </div>
        </section>

        {/* Testimonials */}
        <section className="py-16 bg-gray-50">
          <div className="container mx-auto px-4">
            <h2 className="text-3xl font-bold text-center mb-12">What Our Customers Say</h2>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="bg-white p-6 rounded-xl shadow-md">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center text-teal-600 font-bold mr-4">JD</div>
                  <div>
                    <h4 className="font-bold">John Doe</h4>
                    <div className="flex text-yellow-400">
                      ★ ★ ★ ★ ★
                    </div>
                  </div>
                </div>
                <p className="text-gray-600">"The equipment I rented was in perfect condition, and the staff was incredibly helpful. Will definitely use again!"</p>
              </div>
              
              <div className="bg-white p-6 rounded-xl shadow-md">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center text-purple-600 font-bold mr-4">SM</div>
                  <div>
                    <h4 className="font-bold">Sarah Miller</h4>
                    <div className="flex text-yellow-400">
                      ★ ★ ★ ★ ★
                    </div>
                  </div>
                </div>
                <p className="text-gray-600">"The studio space was perfect for our fashion shoot. Great lighting equipment and plenty of space to work."</p>
              </div>
              
              <div className="bg-white p-6 rounded-xl shadow-md">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center text-blue-600 font-bold mr-4">AR</div>
                  <div>
                    <h4 className="font-bold">Alex Rodriguez</h4>
                    <div className="flex text-yellow-400">
                      ★ ★ ★ ★ ★
                    </div>
                  </div>
                </div>
                <p className="text-gray-600">"The photography workshop was fantastic! I learned so much and the instructors were true professionals."</p>
              </div>
            </div>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div>
              <h3 className="text-xl font-bold mb-4 flex items-center">
                <span className="mr-2">📸</span> PhotoStudio
              </h3>
              <p className="text-gray-400">
                Your one-stop shop for professional photography equipment and studio services.
              </p>
            </div>
            
            <div>
              <h4 className="font-bold mb-4">Shop</h4>
              <ul className="space-y-2">
                <li><a href="#" className="text-gray-400 hover:text-white transition">Cameras</a></li>
                <li><a href="#" className="text-gray-400 hover:text-white transition">Lenses</a></li>
                <li><a href="#" className="text-gray-400 hover:text-white transition">Lighting</a></li>
                <li><a href="#" className="text-gray-400 hover:text-white transition">Accessories</a></li>
              </ul>
            </div>
            
            <div>
              <h4 className="font-bold mb-4">Services</h4>
              <ul className="space-y-2">
                <li><a href="#" className="text-gray-400 hover:text-white transition">Studio Rental</a></li>
                <li><a href="#" className="text-gray-400 hover:text-white transition">Photo Editing</a></li>
                <li><a href="#" className="text-gray-400 hover:text-white transition">Workshops</a></li>
                <li><a href="#" className="text-gray-400 hover:text-white transition">Equipment Repair</a></li>
              </ul>
            </div>
            
            <div>
              <h4 className="font-bold mb-4">Contact</h4>
              <ul className="space-y-2 text-gray-400">
                <li>123 Photography Ave, Studio City</li>
                <li>info@photostudio.com</li>
                <li>+1 (555) 123-4567</li>
              </ul>
              
              <div className="flex space-x-4 mt-4">
                <a href="#" className="text-gray-400 hover:text-white transition">
                  <span className="sr-only">Facebook</span>
                  <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path fillRule="evenodd" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" clipRule="evenodd" />
                  </svg>
                </a>
                <a href="#" className="text-gray-400 hover:text-white transition">
                  <span className="sr-only">Instagram</span>
                  <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path fillRule="evenodd" d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z" clipRule="evenodd" />
                  </svg>
                </a>
                <a href="#" className="text-gray-400 hover:text-white transition">
                  <span className="sr-only">Twitter</span>
                  <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" />
                  </svg>
                </a>
              </div>
            </div>
          </div>
          
          <div className="border-t border-gray-800 mt-12 pt-8 text-center text-gray-400">
            <p>© {new Date().getFullYear()} PhotoStudio. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}